import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { ConnectionUser } from '../../../lib/entities/connection-user';
import { UserApiData } from '../../../types/user';

export const useFetchUser = (userId: string) => {
	const { fromApiData } = ConnectionUser;
	const http = useHttpClient('v2');

	return useQuery(
		[{ userId }],
		async () => {
			const data = await http.get<UserApiData>(`/user_management/users/${userId}`);
			return data;
		},
		{
			select: ({ data }) => {
				return {
					user: { ...fromApiData(data) },
					popoverData: { ...data },
				};
			},
		}
	);
};
